import { t } from 'i18next';
import { useState, useEffect } from 'react'
import { CheckBox } from '../../../../components/controls/checkbox';
import { TextInput } from '../../../../components/controls/inputs';
import { PluginWrapper } from '../../../../components/plugins';
import { Button } from '../../../../components/buttons/button';
import { useAppContext } from '../../../../system/providers/appContextProvider';
import { AuthDataDataProvider } from '../../../../Services/DataProviders/AuthDataDataProvider';
import { IAuthDataViewDTO } from '../../../../libs/coreapi-dto/service/authData';
import styles from '../styles/ConnectionSettingsMarketingEvents.module.scss';
import { useForm } from '../../../../system/hooks/useForm';
import { checkLockStatus } from '../../../CommonHelperFunctions';
import { useUserContext } from '../../../../system/providers/userContextProvider';

interface IValidator extends IAuthDataViewDTO {
}

export const ConnectionSettingsMarketingEventsView = () => {
    const appContext = useAppContext();
    const userContext = useUserContext();
    const baseT = (value: string) => t('directory.contractors.' + value);
    const errorsT = (value: string) => t('errors.' + value);

    const authDataDP = new AuthDataDataProvider(appContext.coreApiService);
    const lockFromPermission = checkLockStatus("ProAptekaMarketing" as IPermission, userContext.userPermission);
    const [connectionData, setConnectionData] = useState<IAuthDataViewDTO>({
        idGlobal: '',
        isEnabled: false,
        serviceName: 'ProAptekaMarketing',
        login: '',
        password: '',
        clientName: "IProAptekaMarketingClient",
        clientId: '',
        appName: 'F3TailWeb',
        url: 'https://api.marketing.external.f3pro.ru'
    })

    const getServiceSettings = () => {
        authDataDP.getServiceName(connectionData.serviceName, (data) => {
            if (data.respType === 'isCompleted') {
                setConnectionData({
                    idGlobal: data?.data?.idGlobal || connectionData.idGlobal,
                    isEnabled: data?.data?.isEnabled || connectionData.isEnabled,
                    serviceName: 'ProAptekaMarketing',
                    login: data?.data?.login || connectionData.login,
                    password: data?.data?.password || connectionData.password,
                    clientName: "IProAptekaMarketingClient",
                    clientId: data?.data?.login || '',
                    appName: 'F3TailWeb',
                    url: 'https://api.marketing.external.f3pro.ru',
                })
            }
        })
    }

    const saveSettings = () => {
        if (!isValid()) return

        if (connectionData.idGlobal) {
            authDataDP.update(connectionData.idGlobal as string, connectionData)
            
        } else {
            const dataObj = connectionData as IAuthDataViewDTO;
            const { idGlobal, ...newData } = dataObj;
            authDataDP.create(newData, (newIdGlobal) => {
                setConnectionData(prev => ({ ...prev, idGlobal: newIdGlobal }))
            })
        }
    }
    
    const onChangeInput = (value: string, name: string) => {
        if (name === 'login') {
            setConnectionData(prev => ({ 
                ...prev, 
                login: value,
                clientId: value
            }));
        } else {
            setConnectionData(prev => ({ ...prev, [name]: value }));
        }
    }
    
    const onCheckboxChange = (value: boolean) => {
        setConnectionData(prev => ({ ...prev, isEnabled: value }));
    }

    const { isValid, errors, setErrors } = useForm<IValidator>({
        validations: {
            login: {
                required: {
                    value: connectionData.isEnabled && !connectionData.login,
                    message: errorsT("required")
                }
            },
            password: {
                required: {
                    value: connectionData.isEnabled && !connectionData.password,
                    message: errorsT("required")
                }
            },
            
        }
    });

    useEffect(() => {
        getServiceSettings();
    }, [])

    useEffect(() => {
        if (!connectionData.isEnabled) {
            setErrors({ 
                ...errors, 
                login: undefined, 
                password: undefined 
            });
        }
    }, [connectionData.isEnabled]);

    return (
        <PluginWrapper>
            <div>
                <CheckBox
                    className={styles.checkboxIsEnabled}
                    id='connectionSettingsIsEnabled'
                    defaultChecked={connectionData.isEnabled}
                    label={baseT('isEnabled')}
                    onChanged={onCheckboxChange}
                    disabled={lockFromPermission}
                />
                <TextInput
                    required
                    error={errors.login}
                    onFocus={() => setErrors({ ...errors, login: undefined })}
                    inline
                    value={connectionData.login}
                    label={baseT('codeConnection')}
                    onChange={(value) => onChangeInput(value, 'login')}
                    disabled={!connectionData.isEnabled || lockFromPermission}
                />
                <TextInput
                    required
                    error={errors.password}
                    onFocus={() => setErrors({ ...errors, password: undefined })}
                    inline
                    value={connectionData.password}
                    label={baseT('password')}
                    onChange={(value) => onChangeInput(value, 'password')}
                    disabled={!connectionData.isEnabled || lockFromPermission}
                />
            </div>
                <Button className={styles.saveSettingsBtn} variant="primary" onClick={saveSettings}>{t('general.save')}</Button>
        </PluginWrapper >
    )
}